import { flashSuccess, flashError } from "./flash";

function updateSOPInstructions(e) {
  console.log("updateSOPInstructions");
  const currentInstructionId = parseInt(e.target.value);
  var selectedValue = null;
  const data = JSON.parse(document.getElementById("sop-instruction-values").dataset.value);
  const values = data.filter((val) => {
    const instructions = val.assignments.map((x) => {
      if (x.is_default) {
        selectedValue = val.id;
      }
      return x.sop_instruction_id;
    });
    return ~instructions.indexOf(currentInstructionId);
  });
  const valueSelect = $("#organization_sop_instruction_sop_instruction_value_id");
  valueSelect.find("option").remove();
  values.forEach((object) => {
    let name = object.name;
    if (selectedValue === object.id) {
      name += " (default)";
    }
    valueSelect.append(`<option value="${object.id}">${name}</option>`);
  });
  valueSelect.val(selectedValue);
}

function updateSOPInstructionValues(e) {
  console.log("updateSOPInstructionValues");
  let select = $(e.target);
  let id = select.data("organizationInstructionId");
  $.ajax({
    method: "PATCH",
    url: `/admin/organization_sop_instructions/${id}`,
    dataType: "JSON",
    data: {
      organization_sop_instruction: {
        sop_instruction_value_id: select.val(),
      },
    },
    success: () => flashSuccess("Updated SOP value!"),
    error: () => flashError("Error: could not update SOP value..."),
  });
}

function updateComment(e) {
  let input = e.target;
  let id = input.dataset.organization_instruction_id;
  $.ajax({
    method: "PATCH",
    dataType: "JSON",
    url: `/admin/organization_sop_instructions/${id}`,
    data: {
      organization_sop_instruction: {
        comment: input.innerText,
      },
    },
    success: () => flashSuccess("Updated SOP comment!"),
    error: () => flashError("Error: could not update SOP comment..."),
  });
}

$(document)
  .on("change", "#organization_sop_instruction_sop_instruction_id", updateSOPInstructions)
  .on("change", "select.sop-instruction-value-select", updateSOPInstructionValues)
  .on("blur", "span.sop-textarea.comment", updateComment);
